import {
  FileSyncOutlined,
  FileExcelOutlined,
  IdcardOutlined,
  MailOutlined,
  SignatureOutlined,
  TeamOutlined,
  SettingOutlined,
  FileTextOutlined,
  LayoutOutlined,
  UserOutlined,
  HistoryOutlined,
  DashboardOutlined,
  UsergroupAddOutlined,
  ContactsOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';

const icons = {
  FileSyncOutlined,
  FileExcelOutlined,
  IdcardOutlined,
  MailOutlined,
  SignatureOutlined,
  TeamOutlined,
  SettingOutlined,
  FileTextOutlined,
  LayoutOutlined,
  UserOutlined,
  HistoryOutlined,
  DashboardOutlined,
  UsergroupAddOutlined,
  ContactsOutlined,
  SafetyCertificateOutlined
};

const flowsign = {
  id: 'group-flowsign',
  title: 'Flowsign',
  type: 'group',
  children: [
    {
      id: 'contracts-th',
      title: 'Contrataciones TH',
      type: 'collapse',
      icon: icons.SignatureOutlined,
      //permissions: ['contract.read-all', 'envelope-ht-contract.create', 'envelope-ht-contract.read-all', 'envelope-ht-contract.read-by-id-ds'],
      children: [
        {
          id: 'contracts-th-dashboard',
          title: 'Inicio / Dashboard',
          type: 'item',
          url: '/flowsign/contracts-th/dashboard',
          icon: icons.DashboardOutlined,
          breadcrumbs: false,
          permissions: ['envelope-ht-contract.view-dashboard-ini']
        },
        {
          id: 'contracts-th-contracts',
          title: 'Contratos',
          type: 'item',
          url: '/flowsign/contracts-th/contracts',
          icon: icons.FileSyncOutlined,
          breadcrumbs: true,
          permissions: ['contract.view-contract']
        },
        {
          id: 'contracts-th-contracts-excel',
          title: 'Contratos Excel',
          type: 'item',
          url: '/flowsign/contracts-th/contracts-excel',
          icon: icons.FileExcelOutlined,
          breadcrumbs: true,
          permissions: ['contract.view-excel']
        },
        {
          id: 'contracts-th-envelopes',
          title: 'Enviados',
          type: 'item',
          url: '/flowsign/contracts-th/envelopes',
          icon: icons.MailOutlined,
          breadcrumbs: true,
          permissions: ['envelope-ht-contract.view-envelope-send']
        },
        {
          id: 'contracts-th-employee-envelopes',
          title: 'Historial',
          type: 'item',
          url: '/flowsign/contracts-th/employee-envelopes',
          icon: icons.HistoryOutlined,
          breadcrumbs: true,
          permissions: ['envelope-ht-contract.view-envelope-history']
        },
        /*{
          id: 'contracts-th-envelopes-by-employee',
          title: 'Sobres por Colaborador',
          type: 'item',
          url: '/flowsign/contracts-th/envelopes-by-employee',
          icon: icons.IdcardOutlined,
          breadcrumbs: true,
          //permissions: ['envelope-ht-contract.read-all', 'envelope-ht-contract.read-by-id-ds']
        },*/
      ]
    },
    {
      id: 'flowsign-configuration',
      title: 'Configuraciones',
      type: 'collapse',
      icon: icons.SettingOutlined,
      children: [
        {
          id: 'contract_types',
          title: 'Tipos de Documentos',
          type: 'item',
          url: '/flowsign/contract_types',
          icon: icons.FileTextOutlined,
          breadcrumbs: true,
          permissions: ['contract-type.view-contract-type']
        },
        {
          id: 'templates',
          title: 'Plantillas',
          type: 'item',
          url: '/flowsign/templates',
          icon: icons.LayoutOutlined,
          breadcrumbs: true,
          permissions: ['template.view-template']
        },
        {
          id: 'responsibles-config',
          title: 'Destinatarios',
          type: 'item',
          url: '/flowsign/responsibles-config',
          icon: icons.ContactsOutlined,
          breadcrumbs: true,
          permissions: ['responsible.view-responsible']
        }
      ]
    }
  ]
};
export default flowsign;
